import { render, staticRenderFns } from "./AssignDriverVehicle.vue?vue&type=template&id=707b5f48&scoped=true&"
import script from "./AssignDriverVehicle.vue?vue&type=script&lang=js&"
export * from "./AssignDriverVehicle.vue?vue&type=script&lang=js&"
import style0 from "./AssignDriverVehicle.vue?vue&type=style&index=0&id=707b5f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b5f48",
  null
  
)

export default component.exports